import ArtifactGroupType from "../base/ArtifactGroupType";


const HelenDress = {
  id: '144',
  name: "Helen's Dress",
  groupIcon: 'LegendsOfTroy',
  type: ArtifactGroupType.LEGENDS_OF_TROY,
  icon: 'HelensDress',
  power: 25
};

export default HelenDress;
